import SearchBox from "../../common_nextgen/common_components/SearchScreenComponents/SearchBox";  
import DisplayTable from "../../common_nextgen/common_components/SearchScreenComponents/DisplayTable";  
import ButtonsSection from "../../common_nextgen/common_components/SearchScreenComponents/ButtonsSection";  
import NextGenPaginator from "../../common_nextgen/common_components/Pagination/NextGenPaginator";  
import useLicsScheduleDetail from "./hooks/useLicsScheduleDetail";  
  
const LicsScheduleDetail = () => {  
  const licsScheduleDetailData = useLicsScheduleDetail();  
  
  return (  
    <div class="container container-fluid">  
        <ButtonsSection ctaButtons={licsScheduleDetailData.leftButtons} align="left" />
      <div className="header-section">  
        <h1>  
          {licsScheduleDetailData.screen_title} -{" "}  
          <span className="heading-cod">{licsScheduleDetailData.screenNumber}</span>  
        </h1>  
      </div>  
      <SearchBox  
        formFields={licsScheduleDetailData.formFields}  
        paramsData={licsScheduleDetailData.paramsData}  
        updataParamData={licsScheduleDetailData.updateParamData}  
      />  
      <ButtonsSection ctaButtons={licsScheduleDetailData.ctaButtons} />  
      <DisplayTable  
        displayMode={licsScheduleDetailData.displayMode}
        data={licsScheduleDetailData.data}  
        parmKey={licsScheduleDetailData.parmKey}  
        menuOptions={licsScheduleDetailData.menuOptions}  
        tableHeaders={licsScheduleDetailData.columnDef}  
        setRowData={licsScheduleDetailData.setRowData}  
        selectedPriceSchedules={licsScheduleDetailData.selectedRows}  
        setSelectedPriceSchedules={licsScheduleDetailData.setSelectedRows}  
      />  
      <div className="paginator-container">  
        <NextGenPaginator  
          first={licsScheduleDetailData.first}  
          rows={licsScheduleDetailData.rows}  
          totalRecords={licsScheduleDetailData.totalRecords}  
          currentPage={licsScheduleDetailData.currentPage}  
          rowsPerPageOptions={[10, 25, 50]}  
          onPageChange={licsScheduleDetailData.onPageChange}  
        />  
      </div>   
    </div>  
  );  
};  
  
export default LicsScheduleDetail;